import { Phone, MessageCircle } from 'lucide-react';
import { BUSINESS, telLink } from '../lib/business';
import { buildWhatsappUrl } from '../lib/whatsapp';

const waLink = buildWhatsappUrl(BUSINESS.whatsapp, 'Hola Zenya, me gustaría agendar una cita.');

const FloatingContactActions = () => (
  <>
    <a
      href={telLink}
      className="z-floating-desktop"
      style={{
        position: 'fixed',
        bottom: 26,
        right: 26,
        zIndex: 60,
        alignItems: 'center',
        gap: 10,
        background: 'var(--rose-700)',
        boxShadow: 'var(--shadow-brand)',
        color: '#FFF',
        borderRadius: 'var(--radius-pill)',
        padding: '15px 22px',
        fontSize: 13.5,
        letterSpacing: '.06em',
      }}
    >
      <Phone size={18} strokeWidth={1.9} />
      Llamar
    </a>

    <div
      className="z-floating-mobile"
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 60,
        background: 'rgba(252,250,248,.96)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid var(--ink-200)',
        padding: '12px 16px calc(12px + env(safe-area-inset-bottom))',
        gap: 10,
      }}
    >
      <a
        href={telLink}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 9,
          border: '1px solid var(--rose-300)',
          color: 'var(--rose-700)',
          borderRadius: 'var(--radius-pill)',
          padding: 15,
          fontSize: 14,
          letterSpacing: '.06em',
        }}
      >
        <Phone size={17} strokeWidth={1.8} />
        Llamar
      </a>
      <a
        href={waLink}
        target="_blank"
        rel="noreferrer"
        style={{
          flex: 1.4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 9,
          background: 'var(--rose-700)',
          color: '#FFF',
          borderRadius: 'var(--radius-pill)',
          padding: 15,
          fontSize: 14,
          letterSpacing: '.06em',
        }}
      >
        <MessageCircle size={18} strokeWidth={1.9} />
        WhatsApp
      </a>
    </div>
  </>
);

export default FloatingContactActions;
